import React from "react";

const ServicePolicySection = (props) => {
  return (
    <div className="service-policy-container">
      <div className="title">サービスポリシー</div>
      <div className="text">
        Trynibus
        サービスポリシー（以下「本ポリシー」といいます。）は、野村證券株式会社（以下「当社」といいます。）が「TRYNIBUS」（以下「本アプリ」といいます。）を通じて収集するお客様に関する情報について、「野村證券　個人情報保護方針」と併せて、その取扱いを明確にし、お客様に本アプリにおいてより良いサービスを提供していくことを目的として定めるものです。
        <br />
        <br />
        1.
        本アプリでは、次に掲げる情報（以下、総称して「本情報」といいます。）を収集いたします。
        <br />
        (1) 本アプリを利用した日時、場所
        <br />
        (2) 本アプリ内の各コンテンツの閲覧情報
        <br />
        (3) 本アプリを利用した情報端末の種別
        <br />
        (4) 本アプリの閲覧に使用したソフトウェア、IPアドレス
        <br />
        (5) 本アプリへの訪問方法を表すリファラル情報
        <br />
        (6) 本アプリへの入力・行動履歴情報
        <br />
        <br />
        ・本情報にはお客様のお名前、電話番号、メールアドレスなどの個人を識別する情報は含まれません。
        <br />
        <br />
        ・本情報の収集には、お客様のブラウザの利用履歴を識別するCookieという技術や本アプリの利用端末を識別するidentifierForVendor（IDFV）やAndroidIDという識別子、本アプリにおける広告識別子等を使用します。
        <br />
        <br />
        2.本アプリで利用する主な情報収集モジュールについて
        <br />
        当社は、お客様による本アプリの利用に関する動向を調査することにより、本アプリにおいてより良いサービスを提供し、適切な広告を表示するため、本アプリとは独立した、第三者が提供する情報収集モジュールを利用します。本アプリにおいて利用する主な情報収集モジュールについては以下をご確認下さい。なお、情報収集モジュールの利用によりお客様に損害が生じたとしても、当社は一切その責任を負わないものとします。
        <br />
        (1) Google AnalyticsおよびFirebase向けGoogle Analytics
        <br />
        <br />
        本アプリでは、お客様による本アプリの利用状況を分析し、本アプリにおいてより良いサービスを提供するため、Google
        AnalyticsおよびFirebase向けGoogle Analyticsを利用します。
        <br />
        Google AnalyticsおよびFirebase向けGoogle
        Analyticsは、Cookieを利用してお客様の情報を収集し、それによって収集された情報はGoogle
        AnalyticsおよびFirebase向けGoogle
        Analyticsに関するポリシーや規約等に基づいて管理されます。
        <br />
        Google AnalyticsおよびFirebase向けGoogle
        Analyticsに関するポリシーや規約等については、以下をご確認下さい。なお、Google
        AnalyticsおよびFirebase向けGoogle
        Analyticsの利用によってお客様に損害が生じたとしても、当社は一切その責任を負わないものとします。
        <br />
        Google Analytics：
        <br />
        https://marketingplatform.google.com/intl/ja/about/analytics/
        <br />
        <br />
        Firebase向けGoogle Analytics：
        <br />
        https://firebase.google.com/products/analytics?hl=ja
        <br />
        <br />
        Google ポリシーと規約：
        <br />
        https://policies.google.com/technologies/partner-sites
        <br />
        <br />
        Google プライバシーポリシー：
        <br />
        https://policies.google.com/privacy?hl=ja
        <br />
        <br />
        本アプリにおいてGoogle
        Analyticsによる情報収集を拒否される場合は、以下のWebサイト（Google
        アナリティクス オプトアウトアドオン）より、Google
        Analyticsを無効化することができます。
        <br />
        https://tools.google.com/dlpage/gaoptout?hl=ja
        （左記のURLを長押しし、「リンクを開く」からお進みください。）
        <br />
        <br />
        (2) adjust
        <br />
        <br />
        本アプリでは、adjust,Inc.（以下「adjust社」といいます。）が提供するadjustを利用します。
        <br />
        adjustによって収集された情報は、adjust社のプライバシーポリシーや規約等に基づいて管理されます。
        <br />
        adjust社のプライバシーポリシーについては、以下をご確認下さい。
        <br />
        adjust社 プライバシーポリシー
        <br />
        https://www.adjust.com/ja/privacy-policy/
        <br />
        <br />
        adjust 社オプトアウトリンク：
        <br />
        https://www.adjust.com/ja/forget-device/
        <br />
        <br />
        (3) REPRO
        <br />
        <br />
        本アプリでは、Repro株式会社（以下「Repro社」といいます）が提供するReproを利用します。
        <br />
        Reproによって収集された情報は、Repro社のプライバシーポリシーや規約等に基づいて管理されます。
        <br />
        Repro社のプライバシーポリシーについては、以下をご確認下さい。
        <br />
        Repro社 プライバシーポリシー
        <br />
        https://repro.io/company/legal/privacy/
        <br />
        <br />
        3.本アプリでは、広告配信事業者等、当社以外の事業者が独自にアクセスデータを収集し、行動ターゲティング広告の配信等の目的に利用します。これら事業者は、収集された本情報をさらに他の事業者に提供する場合があります。
        <br />
        4.
        当社および野村グループ各社は、当社が収集した本情報を次の用途に利用します。
        <br />
        <br />
        (1) 本アプリの利用状況の解析・改善
        <br />
        <br />
        (2) お客様向けサービスの利用状況の確認
        <br />
        <br />
        (3) 当社および野村グループ各社のマーケティング活動における利用
        <br />
        <br />
        (4) お客様向けの広告配信を目的とした本情報の解析・活用
        <br />
        <br />
        5.
        前項に定める用途に利用するため、当社は当社が収集した本情報を野村グループ各社に提供することがあります。
        <br />
        <br />
        当社は、当社が収集した本情報がお客様にとって大切な情報であることを理解し、安全かつ適正に保管および利用いたします。当社の「個人情報保護方針」は、以下をご確認下さい。
        <br />
        <br />
        野村證券　個人情報保護方針
        <br />
        https://www.nomura.co.jp/guide/privacy.html
        <br />
        <br />
        附則
        <br />
        2020年6月25日&nbsp;&nbsp;制定・施行
        <br />
        2020年12月22日&nbsp;&nbsp;改定
        <br />
        2021年1月28日&nbsp;&nbsp;改定
      </div>
    </div>
  );
};

export default ServicePolicySection;
